import LogsConstant from "../constants/LogsConstant"
 
export const replaceTags = (_line, _user) => {
    var line = _line;
    if(_line.includes(LogsConstant.TAGS_USER_NAME)){
        line = line.replace(LogsConstant.TAGS_USER_NAME, _user);
    }
    return line;
}